import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '../store';
import {
  GlossarySuggestion,
  ISuggestionsSliceState,
  SuggestionID,
} from './suggestions.types';

export const initialState: ISuggestionsSliceState = {
  suggestions: {},
};

export const suggestionsSlice = createSlice({
  name: 'suggestions',
  initialState,
  reducers: {
    setSuggestions(
      state: ISuggestionsSliceState,
      { payload }: PayloadAction<GlossarySuggestion[]>,
    ) {
      const suggestions: Record<SuggestionID, GlossarySuggestion> = {};

      payload.forEach((g) => {
        suggestions[g.id] = {
          id: g.id,
          user: g.user,
          source: g.source,
          target: g.target,
           
          content: state.suggestions[g.id]?.content ?? {},
        };
      });

      state.suggestions = suggestions;
    },
    setSuggestion(
      state,
      {
        payload: { id, data },
      }: PayloadAction<{ id: string } & { data: GlossarySuggestion }>,
    ) {
      state.suggestions[id] = data;
    },
    removePairsFromSuggestion(
      state,
      {
        payload: { suggestionId, terms },
      }: PayloadAction<{ suggestionId: string; terms: string[] }>,
    ) {
      const suggestion = state.suggestions[suggestionId];

      if (!suggestion) return;

      terms.forEach((t) => {
         
        delete suggestion.content[t];
      });

      // 2. If no pairs left → remove entire suggestion
       
      if (Object.keys(suggestion.content).length === 0 || terms.length === 0) {
        delete state.suggestions[suggestionId];
      }
    },
  },
});

export const { setSuggestions, setSuggestion, removePairsFromSuggestion } =
  suggestionsSlice.actions;

export const suggestionsSelector = (state: RootState): ISuggestionsSliceState =>
  state.suggestions;

export const selectSuggestions = createSelector(
  suggestionsSelector,
  (state) => state.suggestions,
);
